'use es6';

import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const Hreflang = ({
  href,
  lang
}) => {
  return /*#__PURE__*/_jsx("link", {
    rel: "alternate",
    hrefLang: lang,
    href: href
  });
};
Hreflang.propTypes = {
  href: PropTypes.string.isRequired,
  lang: PropTypes.oneOf(['x-default', 'en', 'de', 'es', 'fr', 'ja', 'pt']).isRequired
};
export default Hreflang;